/**
 * Admin Localization Settings page — localization manifest.
 */
export const adminLocalizationManifest: readonly string[] = [
  "admin.localization.title",
  "admin.localization.defaultLanguage",
  "admin.localization.availableLanguages",
  "admin.localization.userLanguage",
  "admin.localization.saved",
  "admin.localization.description",
  "admin.localization.manageOverrides",
  // Shared
  "common.save",
  "common.cancel",
  "common.loading",
] as const;

/**
 * Admin Translation Overrides page — localization manifest.
 */
export const adminOverridesManifest: readonly string[] = [
  "admin.translationOverrides.title",
  "admin.translationOverrides.description",
  "admin.translationOverrides.addNew",
  "admin.translationOverrides.addTitle",
  "admin.translationOverrides.editTitle",
  "admin.translationOverrides.deleteTitle",
  "admin.translationOverrides.deleteConfirm",
  "admin.translationOverrides.saved",
  "admin.translationOverrides.deleted",
  "admin.translationOverrides.locale",
  "admin.translationOverrides.allLocales",
  "admin.translationOverrides.sourceText",
  "admin.translationOverrides.sourceTextPlaceholder",
  "admin.translationOverrides.sourceTextHint",
  "admin.translationOverrides.translatedText",
  "admin.translationOverrides.translatedTextPlaceholder",
  "admin.translationOverrides.scope",
  "admin.translationOverrides.scopeCompany",
  "admin.translationOverrides.scopeGlobal",
  "admin.translationOverrides.makeGlobal",
  // Shared
  "common.save",
  "common.cancel",
  "common.delete",
  "common.edit",
  "common.loading",
  "common.noData",
  "common.search",
  "common.actions",
  "common.confirm",
] as const;

/**
 * Admin Typography Settings page — localization manifest.
 */
export const adminTypographyManifest: readonly string[] = [
  "admin.typography.title",
  "admin.typography.description",
  "admin.typography.headingFont",
  "admin.typography.headingFontSize",
  "admin.typography.gridHeaderFont",
  "admin.typography.gridHeaderFontSize",
  "admin.typography.gridRowFont",
  "admin.typography.gridRowFontSize",
  "admin.typography.menuFont",
  "admin.typography.menuFontSize",
  "admin.typography.navigationFont",
  "admin.typography.navigationFontSize",
  "admin.typography.labelFont",
  "admin.typography.labelFontSize",
  "admin.typography.preview",
  "admin.typography.saved",
  "admin.typography.reset",
  "admin.typography.useDefault",
  // Shared
  "common.save",
  "common.cancel",
  "common.loading",
] as const;

/**
 * Admin Region Settings page — localization manifest.
 */
export const adminRegionManifest: readonly string[] = [
  "admin.region.title",
  "admin.region.description",
  "admin.region.currency",
  "admin.region.timezone",
  "admin.region.dateFormat",
  "admin.region.numberFormat",
  "admin.region.preview",
  "admin.region.saved",
  "common.save",
  "common.cancel",
  "common.loading",
] as const;

/**
 * Admin Localization Health page — localization manifest.
 */
export const adminLocalizationHealthManifest: readonly string[] = [
  "admin.l10nHealth.title",
  "admin.l10nHealth.description",
  "admin.l10nHealth.coverage",
  "admin.l10nHealth.mostUsed",
  "admin.l10nHealth.leastUsed",
  "admin.l10nHealth.averageCoverage",
  "admin.l10nHealth.noData",
  "common.loading",
] as const;

/**
 * Admin AI Translation Suggestions page — localization manifest.
 */
export const adminAISuggestionsManifest: readonly string[] = [
  "admin.aiSuggestions.title",
  "admin.aiSuggestions.description",
  "admin.aiSuggestions.generate",
  "admin.aiSuggestions.locale",
  "admin.aiSuggestions.sourceText",
  "admin.aiSuggestions.sourceTextPlaceholder",
  "admin.aiSuggestions.suggestedText",
  "admin.aiSuggestions.confidence",
  "admin.aiSuggestions.accept",
  "admin.aiSuggestions.reject",
  "admin.aiSuggestions.pending",
  "admin.aiSuggestions.reviewed",
  "admin.aiSuggestions.accepted",
  "admin.aiSuggestions.rejected",
  "admin.aiSuggestions.noSuggestions",
  "admin.aiSuggestions.generating",
  "common.loading",
  "common.actions",
] as const;

/**
 * Admin Community Translations Contributions page — localization manifest.
 */
export const adminContributionsManifest: readonly string[] = [
  "admin.contributions.title",
  "admin.contributions.description",
  "admin.contributions.submit",
  "admin.contributions.locale",
  "admin.contributions.sourceText",
  "admin.contributions.sourceTextPlaceholder",
  "admin.contributions.translatedText",
  "admin.contributions.translatedTextPlaceholder",
  "admin.contributions.approve",
  "admin.contributions.reject",
  "admin.contributions.pending",
  "admin.contributions.reviewed",
  "admin.contributions.approved",
  "admin.contributions.rejected",
  "admin.contributions.noContributions",
  "common.loading",
  "common.actions",
] as const;
